import { useEffect, useState } from 'react'
import { offlineQueue } from '@/state/offlineQueue'

export function useOfflineQueueStatus() {
  const [queueCount, setQueueCount] = useState(offlineQueue.getState().items.length)

  useEffect(() => {
    const unsubscribe = offlineQueue.subscribe((state) => {
      setQueueCount(state.items.length)
    })

    setQueueCount(offlineQueue.getState().items.length)
    return unsubscribe
  }, [])

  return { queueCount }
}
